import { Box, Button, Typography } from '@mui/material';
import React, { useState } from 'react';
import { InputCompo } from '../../../InputCompo/InputCompo';
import CustomInput from '../../../InputCompo/CustomInput';
import CustomTextarea from '../../../textareaComp/CustomTextarea';
import axios from 'axios';
import { enqueueSnackbar } from 'notistack';
import { hoverImages } from '../../../HeaderSec/HeaderSecDatas';
import HoverImage from '../../../HeaderSec/hoverImage';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { ParagraphComp } from '../../../ParagraphComp/ParagraphComp';
import { error } from 'ajv/dist/vocabularies/applicator/dependencies';

const ContactLanding = () => {
    const validationSchema = Yup.object().shape({
        name: Yup.string().required('Name is required'),
        email: Yup.string().matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, 'Invalid email address').required('Email is required'),
        number: Yup.string()
            .matches(/^[0-9]{10}$/, 'Mobile number must be 10 digits')
            .required('Mobile number is required'),
        message: Yup.string().required('Message is required'),
        checkbox: Yup.boolean()
            .oneOf([true], 'You must accept the terms & conditions')
    });
    const submitData = async (values) => {
        console.log("values>>>>", values)
        const serviceId = 'service_36q8ji9';
        const templateId = 'template_7fupf2o';
        const publicKey = 'J15VHkYtAyLaO9WzF';

        const data = {
            service_id: serviceId,
            template_id: templateId,
            user_id: publicKey,
            template_params: {
                from_name: values?.name,
                from_email: values?.email,
                to_name: 'GuideStar India',
                message: values?.message,
                mobile_number: values?.number,
            },
        };

        try {
            const res = await axios.post('https://api.emailjs.com/api/v1.0/email/send', data);
            enqueueSnackbar('Message send successful')
        } catch (error) {
        }
    };



    return (
        <Box sx={{ maxWidth: '1200px', margin: 'auto', color: 'black', padding: '40px 0px' }}>
            <Typography variant="h4" sx={{ textAlign: 'center', fontWeight: 700, paddingBottom: '30px' }}>
                Contact Us
            </Typography>
            <Typography variant="h5" sx={{ textAlign: 'center', fontWeight: 600 }}>
                Let us know how we can help you
            </Typography>
            <Typography variant="subtitle1" sx={{ textAlign: 'center', fontWeight: 400, paddingBottom: '20px' }}>
                Fill out the form and we'll be in touch with you soon!
            </Typography>
            <Formik
                initialValues={{
                    name: '',
                    email: '',
                    message: '',
                    number: ''
                }}
                validationSchema={validationSchema}
                onSubmit={(values) => { submitData(values) }}
            >
                {({ values, errors, handleChange, setFieldValue }) => (

                    <Form >
                        <div className="flex w-[100%] gap-[20px]" >
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '36px', width: '50%' }}>
                                <div >
                                    <CustomInput
                                        required
                                        value={values?.name}
                                        onChange={handleChange}
                                        name="name"
                                        label="Your Name"
                                    />
                                    {(errors?.name && values?.name) &&
                                        <ParagraphComp className='text-[red] mt-[5px] text-[12px]'>
                                            {errors?.name}
                                        </ParagraphComp>
                                    }
                                </div>
                                <div>
                                    <CustomInput
                                        required
                                        value={values?.email}
                                        onChange={handleChange}
                                        name="email"
                                        label="Your email Address"
                                    />
                                    {(errors?.email && values?.email) &&
                                        <ParagraphComp className='text-[red] mt-[5px] text-[12px]'>
                                            {errors?.email}
                                        </ParagraphComp>
                                    }

                                </div>
                                <div>

                                    <CustomInput

                                        value={values?.number}
                                        onChange={handleChange}
                                        name="number"
                                        label="Your Mobile Number"
                                        type='number'
                                    />
                                    {(errors?.number && values?.number) &&
                                        <ParagraphComp className='text-[red] mt-[5px] text-[12px]'>
                                            {errors?.number}
                                        </ParagraphComp>
                                    }

                                </div>
                            </Box>
                            <Box sx={{ display: 'flex', flexDirection: 'column', width: '50%' }}>
                                <div>
                                    <CustomTextarea
                                        required
                                        value={values?.message}
                                        onChange={handleChange}
                                        name="message"
                                        label="Your Message"
                                        className="resize-none"
                                    />
                                    {(errors?.message && values?.message) &&
                                        <ParagraphComp className='text-[red] mt-[2px] ml-1 text-[12px]'>
                                            {errors?.message}
                                        </ParagraphComp>
                                    }
                                </div>

                                {/* <TextField
                        required
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                        name="message"
                        label="Your Message"
                        multiline
                        sx={{
                            // overflow:'hidden',
                            height: "240px", // Container height
                        "& .MuiInputBase-root": {
                            height: "100%", // Make input fill the container
                            alignItems: "start", // Align text at the top
                            overflow:'hidden',
                        },
                        }}
                    /> */}
                            </Box>
                        </div>

                        <Box sx={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', margin: '20px 0', alignItems: 'center' }}>
                            <label className="flex items-start space-x-2 w-[50%]">
                                <InputCompo
                                    className="bg-[#004878] text-white w-[20px] h-[20px] mt-[6px]"
                                    type="checkbox"
                                    name="checkbox"
                                />
                                <span className="text-black">
                                    I accept the terms & conditions and I understand that my data will be held securely in accordance with the privacy policy.
                                </span>
                            </label>

                            <Button type='submit' variant='contained' className="px-[20px] rounded-[10px] bg-[#004878] text-[white] h-[40px] py-[2px]">Submit</Button>
                        </Box>
                    </Form>
                )
                }
            </Formik >
            <Box sx={{ display: 'flex', gap: '20px', marginTop: '50px', justifyContent: 'center', alignItems: 'center' }}>
                <Typography variant="h5" sx={{ textAlign: 'center', fontWeight: 500 }}>
                    Meanwhile, visit our forum and other social channels!
                </Typography>
                <Box sx={{ width: '50px', height: '.5px', backgroundColor: '#ccc' }}></Box>

                <div className='flex items-center gap-3'>
                    <div className='flex flex-col'>

                        <Box sx={{
                            display: "flex",
                            justifyContent: "end",
                            gap: "15px",
                            "& img": { height: "18px", width: "auto" },
                        }}>
                            {hoverImages.slice(3, 6).map((image, index) => (
                                <HoverImage
                                    key={index}
                                    defaultSrc={image.defaultSrc}
                                    hoverSrc={image.hoverSrc}
                                    alt={image.alt}
                                    link={image.link}
                                />
                            ))}

                            {hoverImages.slice(0, 3).map((image, index) => (
                                <HoverImage
                                    key={index}
                                    defaultSrc={image.defaultSrc}
                                    hoverSrc={image.hoverSrc}
                                    alt={image.alt}
                                    link={image.link}
                                />
                            ))}
                        </Box>
                    </div>
                </div>
            </Box>
        </Box >
    );
};

export default ContactLanding;
